import {
  useDisclosureStoreOptions,
  useDisclosureStoreProps
} from "./HN4VMOUI.js";
import {
  useStore
} from "./AV5WE37O.js";
import {
  __spreadValues
} from "./4BKCJXBM.js";

// src/dialog/dialog-store.ts
import * as Core from "@ariakit/core/dialog/dialog-store";
function useDialogStoreOptions(props) {
  return useDisclosureStoreOptions(props);
}
function useDialogStoreProps(store, props) {
  return useDisclosureStoreProps(store, props);
}
function useDialogStore(props = {}) {
  const options = useDialogStoreOptions(props);
  const store = useStore(
    () => Core.createDialogStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useDialogStoreProps(store, props);
}

export {
  useDialogStoreOptions,
  useDialogStoreProps,
  useDialogStore
};
